// extracted by mini-css-extract-plugin
export default {"toast-props":"toastProps_toast-props__MJzW5","toast-props__body":"toastProps_toast-props__body__8VAgI"};